import React from "react";
import AwareImg from "../assets/images/new-dashboards/aware.png";
import AnalyticsIcon from "../assets/icons/analytics.png";
import ReportIcon from "../assets/icons/report.png";
import MachineIcon from "../assets/icons/machine.png";

import { ContactForm } from "../components/ContactForm";

export function LucidAware() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="newModuleHeader">
        <div className="newBackground"></div>
        <h3 className="mainSubhead white">Alpaca Aware</h3>
        <p className="body-text white">
          Leverage machine-data to drive the right decisions.
        </p>
        <img
          src={AwareImg}
          alt="Alpaca Aware Dashboard"
          className="module-img"
        />
      </section>

      <section className="module-info">
        <div>
          <p className="body-text left">
            Alpaca Aware integrates seamlessly with the Alpaca ShopFloor and
            allows users to discover how to improve processes,
            <strong>
              avoid disruption on the shop floor, keep product moving and
              prevent routing collisions or bottlenecks.
            </strong>
            <br />
            <br />
            Make improvements or implement adjustments that you never imagined
            could optimize operations. Alpaca Aware is easy to use and data is
            presented in a single dashboard, making it easy to visualize and
            interpret operations.{" "}
            <strong>Receive operational feedback quickly</strong>, such as
            shift, employee or machine-specific information.
          </p>
        </div>
        <div>
          <div className="container-img-text">
            <img src={AnalyticsIcon} alt="Analytics Icon" />
            <div>
              <h3 className="smallSubhead">Detailed Analytics</h3>
              <p className="small-text">
                Make data-driven decisions using real-time predictive analytics
                and gain insights to direct, coordinate and execute your
                manufacturing strategy.
              </p>
            </div>
          </div>
          <div className="container-img-text">
            <img src={ReportIcon} alt="Report Icon" />
            <div>
              <h3 className="smallSubhead">Structured Reports</h3>
              <p className="small-text">
                Generate reports on your production and inventory planning and
                control, or get a birds-eye view of performance, deviations, and
                predictors of future inventories and contracts.
              </p>
            </div>
          </div>
          <div className="container-img-text">
            <img src={MachineIcon} alt="Machine Learning Icon" />
            <div>
              <h3 className="smallSubhead">Machine Learning</h3>
              <p className="small-text">
                Expand the limits of your production facility with machine
                learning. Combining computer science and artificial intelligence
                to improve accuracy, increase work flow, and streamline your
                process.
              </p>
            </div>
          </div>
        </div>
      </section>

      <ContactForm />
    </>
  );
}
